import { Container } from '@/components/ui/template/Container'
import { SlideIn } from '../../../components/ui/transitions/SlideIn'
import { ExchangeDropdown } from '@/components/ExchangeDropdown'
import { ButtonLink } from '@/components/ui/Button'
import { testIdFactory } from '@/utils/test-id-factory.ts'

export function TopSection() {
	return (
		<Container>
			<picture>
				{/* <-- Mobile devices --> */}
				<source
					media="(max-width: 767px)"
					srcSet="/images/homepage-bg/mobile/homepage-bg-640.webp 1x, /images/homepage-bg/mobile/homepage-bg-1200.webp"
					sizes="100vw"
				/>
				{/* <-- Tablets and Smaller Desktops --> */}
				<source
					media="(min-width: 768px) and (max-width: 1649px)"
					srcSet="/images/homepage-bg/homepage-bg-1280.webp 1280w,
						/images/homepage-bg/homepage-bg-1804.webp 1804w"
					sizes="100vw"
				/>
				{/* <-- Large Desktops --> */}
				<source
					media="(min-width: 1650px)"
					srcSet="/images/homepage-bg/homepage-bg-1804-wide.webp 1804w,
						/images/homepage-bg/homepage-bg-2412-wide.webp 2412w"
					sizes="100vw"
				/>
				<img
					src="/images/homepage-bg/homepage-bg-640.png"
					alt="Homepage BG"
					className="absolute inset-0 w-full h-full object-cover z-0"
				/>
			</picture>
			<Container.Content className="flex flex-col justify-center items-center relative text-center px-6 pt-[140px] md:pt-[140px] pb-12 lg:pt-36 lg:pb-20 lg:px-0 gap-3 lg:gap-0 text-neutral md:min-h-[300px] lg:min-h-[450px] leading-none">
				<SlideIn
					from="top"
					transition={{ duration: 1, type: 'spring', bounce: 0.65, delay: 0.25 }}
					className="flex flex-col gap-5"
				>
					<h2 className="text-[3.5rem] md:text-[3.75rem] lg:text-[6rem] leading-none uppercase">
						$PEPPER IS
						<br />
						FOR THE PEOPLE
					</h2>
					<div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4">
						<ExchangeDropdown />
						<ButtonLink
							to="/pepper-inc"
							variant="frost"
							className="leading-none py-5 px-10"
							data-testid={testIdFactory.homeStakeAndVoteButton()}
						>
							Stake & Vote
						</ButtonLink>
					</div>
				</SlideIn>
			</Container.Content>
		</Container>
	)
}
